import React, { lazy } from "react";

const LazyReviews = lazy(() => import("./Reviews"));

const Reviews = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyReviews {...props} />;

export default Reviews;
